import { render, staticRenderFns } from "./GammaStepper.vue?vue&type=template&id=422b499a&scoped=true"
import script from "./GammaStepper.vue?vue&type=script&lang=ts"
export * from "./GammaStepper.vue?vue&type=script&lang=ts"
import style0 from "./GammaStepper.vue?vue&type=style&index=0&id=422b499a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b499a",
  null
  
)

export default component.exports